import { useLazyFetch } from '@hn-front/utils';
import { useCallback } from 'react';
import { getGeneratePasswordProps } from '../api';
var usePassword = function (groupId) {
    var _a = useLazyFetch({
        isCache: false,
        isStale: true,
    }), makeFetchPasswordRequest = _a[0], _b = _a[1], error = _b.error, response = _b.response, state = _b.state;
    var password = state === 'success' ? response === null || response === void 0 ? void 0 : response.password : undefined;
    var getPassword = useCallback(function () {
        var _a = getGeneratePasswordProps(groupId), url = _a.url, params = _a.params;
        makeFetchPasswordRequest(url, params);
    }, [groupId, makeFetchPasswordRequest]);
    var captureError = useCallback(function () {
        var _a;
        if (error) {
            (_a = window === null || window === void 0 ? void 0 : window.Sentry) === null || _a === void 0 ? void 0 : _a.captureException(error);
        }
    }, [error]);
    return { password: password, getPassword: getPassword, captureError: captureError };
};
export { usePassword };
